<template>
  <div
    class="border-y border-y-black border-x-0 w-full border pt-[1rem] pb-[1.5rem] flex flex-col items-center gap-[1rem]"
  >
    <p v-if="title" class="text-[1rem] font-semibold uppercase mb-0">
      {{ title }}
    </p>
    <div class="grid grid-cols-2 gap-[2rem] @[500px]:grid-cols-3">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps<{ title: string | null }>()
</script>
